import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Link } from 'react-router'

const QA = [
  {
    question: '轻松聊是什么？',
    answer:
      '轻松聊是婚礼纪基于用户行为捕捉开发的一款商家营销工具，系统会捕捉到对商家/套餐/案例有意向的用户，自动展示商家预设的接客问候语（接客问候也会展示在私信记录中），引导用户主动向商家发起私信。'
  },
  {
    question: '所有商家都可以开通轻松聊么？',
    answer: '只有开通了商家服务（付费）的商家才可以开通轻松聊。'
  },
  {
    question: '怎么设置轻松聊？',
    answer:
      '商家可以从首页或营销中心进入轻松聊，在“轻松聊”页面中针对不同的场景，选择或自定义自己想要的接客问候，保存后即发布成功。用户浏览商家的店铺/套餐/案例详情页时，都将收到接客问候。如审核工作员，发现商家设置的问候有不妥之处，则会下架相关的问候，并告知商家修改。'
  },
  {
    question: '编辑的接客问候未通过审核怎么办？',
    answer: '您可以根据“未通过原因”，对接客问候进行编辑修改后再次提交。'
  },
  {
    question: '何种原因会被关闭轻松聊功能？',
    answer:
      '开通轻松聊的商家在每日9:00~21:00期间超过10分钟未回复用户累计多次。则系统会自动下架该商家的轻松聊功能。轻松聊被关闭后，则设置的接客问候在app内无法触发。被强制关闭的商家有可能会受到降分或无法再次申请开通的处罚。'
  },
  {
    question: '被关闭轻松聊功能后还可以再次开通么？',
    answer:
      '被关闭的商家可再次申请开通，如系统曾检测到商家出现多次回复用户私信不及时或有用户投诉、评分过低等，则有可能无法再次开通轻松聊功能。'
  }
]
export default class extends Component {
  render() {
    const header = [
      <Link to="/localMerchant/easyChat">轻松聊</Link>,
      '轻松聊说明'
    ]
    return (
      <HeaderView title="轻松聊说明" header={header}>
        <div style={{ padding: 40 }}>
          <div style={{ height: 160, width: 880, marginBottom: 20 }}>
            <img
              src="http://qnm.hunliji.com/o_1bk3fnk51su85a81lj41o5b17f87.jpg"
              width="100%"
            />
          </div>
          {QA.map(({ question, answer }, index) => (
            <div key={index} style={{ padding: '0 30px' }}>
              <p style={{ padding: '15px 0 0', color: '#000', fontSize: 16 }}>
                Q：{question}
              </p>
              <p style={{ padding: '15px 0', color: '#484848', fontSize: 14 }}>
                A：{answer}
              </p>
            </div>
          ))}
        </div>
      </HeaderView>
    )
  }
}
